var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "con_stage__side-bauteil",
      class: `con_stage__side-bauteil--${_vm.bauteil.orientation}`,
    },
    [
      _c("div", { staticClass: "con_stage__side-text" }, [
        !_vm.isMobile
          ? _c("p", {
              staticClass: "subline subline--bold",
              domProps: { innerHTML: _vm._s(_vm.bauteil.name) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.bauteil.description) } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "con_stage__side-imagewrapper" }, [
        _c("div", { staticClass: "con_stage__side-imagewrapper__inner" }, [
          _c(
            "div",
            {
              staticClass:
                "con_stage__side-imagelabel con_stage__side-imagelabel--top",
            },
            [_vm._v(_vm._s(_vm.bauteil.label_top))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "con_stage__side-image",
              on: { click: _vm.debugMousePosition },
            },
            [
              _c("global-responsive-image", {
                key: _vm.bauteil.name,
                attrs: { responsiveImage: _vm.bauteil.image, lazy: false },
              }),
              _vm._v(" "),
              _vm._l(_vm.bauteil.schichten, function (schicht, index) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "con_stage__side-marker-wrapper",
                      style: _vm.getStyleForMarker(schicht.position),
                      on: {
                        mouseenter: function ($event) {
                          return _vm.setSelectSchicht(schicht)
                        },
                        mouseleave: function ($event) {
                          return _vm.setSelectSchicht(null)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "con_stage__side-marker",
                          class: {
                            "con_stage__side-marker--active":
                              _vm.selectedSchicht === schicht,
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(index + 1) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "con_stage__side-imagelabel con_stage__side-imagelabel--bottom",
            },
            [_vm._v(_vm._s(_vm.bauteil.label_bottom))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "con_stage__side-schichten" },
        _vm._l(_vm.bauteil.schichten, function (schicht, index) {
          return _c(
            "li",
            {
              staticClass: "con_stage__side-schicht",
              class: {
                "con_stage__side-schicht--active":
                  _vm.selectedSchicht === schicht,
              },
              on: {
                mouseenter: function ($event) {
                  return _vm.setSelectSchicht(schicht)
                },
                mouseleave: function ($event) {
                  return _vm.setSelectSchicht(null)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "con_stage__side-marker",
                  class: {
                    "con_stage__side-marker--active":
                      _vm.selectedSchicht === schicht,
                  },
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(index + 1) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              schicht.url
                ? [
                    _c("a", {
                      staticClass: "button button--brand",
                      attrs: { href: schicht.url, target: "_blank" },
                      domProps: { innerHTML: _vm._s(schicht.name) },
                      on: {
                        click: function ($event) {
                          return _vm.handleSchichtClick(schicht)
                        },
                      },
                    }),
                  ]
                : [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(schicht.name) },
                    }),
                  ],
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }